module.exports = __webpack_public_path__ + "static/media/台灣國際專案管理師協會.85e9679f.jpg";